import { ColorTypes } from '@app/lib/Scenes/colorActions'

export const checkIfColorActionRGBOrSwatchType = (colorType: string): boolean => colorType === ColorTypes.rgb || colorType === ColorTypes.swatch
